import React from 'react';
import './AddGroupModal.scss';

interface AddGroupModalProps {
  isOpen: boolean;
  groupName: string;
  onGroupNameChange: (name: string) => void;
  onConfirm: () => void;
  onClose: () => void;
}

const AddGroupModal: React.FC<AddGroupModalProps> = ({
  isOpen,
  groupName,
  onGroupNameChange,
  onConfirm,
  onClose,
}) => {
  if (!isOpen) return null;

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onConfirm();
    }
  };

  return (
    <div className="tip-modal-overlay" onClick={onClose}>
      <div className="tip-modal" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">Crear Nuevo Grupo</h3>
        <input
          type="text"
          placeholder="Nombre del grupo"
          value={groupName}
          onChange={e => onGroupNameChange(e.target.value)}
          onKeyPress={handleKeyPress}
          className="modal-input"
          autoFocus
        />
        <div className="modal-actions">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
           <button className="btn btn-primary" onClick={onConfirm}>
            Crear
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddGroupModal;
